export default __webpack_public_path__ + "static/media/EILEARN.849f6643.png";